(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

export var pi = Math.PI;
export var tau = 2 * Math.PI;
export var e = Math.E;
export var phi = 1.6180339887498948; // eslint-disable-line no-loss-of-precision

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(pi, "pi", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/constants.js");
  reactHotLoader.register(tau, "tau", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/constants.js");
  reactHotLoader.register(e, "e", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/constants.js");
  reactHotLoader.register(phi, "phi", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/constants.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();